import { BaseRestRepository } from './baseRestRepository';
import type { GetIrisSubmissionStatusResponseDto, SubmitIrisCorrectionDto, SubmitIrisTransmissionDto } from '~/swagger/portal/Api';

const IRS_URL = '/api/irs';

export class IRSRepository extends BaseRestRepository {
  public async submitIrisTransmission(payload: SubmitIrisTransmissionDto): Promise<GetIrisSubmissionStatusResponseDto> {
    const url = `${IRS_URL}/submissions`;
    const response = await this.fetchWithAuth(
      url,
      {
        method: 'POST',
        body: JSON.stringify(payload),
      },
      false
    );
    return this.getJsonResponse(response);
  }

  public async submitIrisCorrection(payload: SubmitIrisCorrectionDto): Promise<GetIrisSubmissionStatusResponseDto> {
    const url = `${IRS_URL}/submissions/corrections`;
    const response = await this.fetchWithAuth(
      url,
      {
        method: 'POST',
        body: JSON.stringify(payload),
      },
      false
    );
    return this.getJsonResponse(response);
  }
}
